/* eslint-disable @next/next/no-img-element */
import { Transition } from '@headlessui/react';
import React, { Fragment, useEffect, useState } from 'react';

const AnimatedNeki = (props) => {
  const { show } = props;
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    if (show) {
      setShowIcon(show);
      setTimeout(() => {
        setShowIcon(false);
      }, 800);
    }
  }, [show]);

  return (
    <Transition
      as={Fragment}
      show={showIcon}
      enter="transform transition duration-700 bg-transparent"
      enterFrom="opacity-0 scale-50 translate-y-0"
      enterTo="opacity-100 scale-100 -translate-y-8"
      leave="transform duration-500 transition ease-in-out"
      leaveFrom="opacity-100 scale-100 -translate-y-8"
      leaveTo="opacity-0 scale-200 -translate-y-32">
      <img
        src="/assets/images/neki-logo.svg"
        alt="thank you from neki"
        width={60}
        height={60}
      />
    </Transition>
  );
};

export default AnimatedNeki;
